import React, { FC } from "react";
import { Box } from "theme-ui";

interface SubmitErrorProps {
  message: string | undefined;
}
export const SubmitError: FC<SubmitErrorProps> = ({
  message,
}: SubmitErrorProps) => (
  <Box variant="forms.alerts.error.box">
    <Box variant="forms.alerts.error.message">{message}</Box>
  </Box>
);
